const DEFAULT_SETTINGS = {
    value: {
        isAnimationOn: true,
        isGlowOn: false,
        glowThreshold: '+100%',
        isFireworkOn: true,
        fireworkThreshold: '+3%',
        chartMathFunction: 'Linear'
    }
};

function getConfigureControlSettings() {
    try {
        const getCache = window.getCacheItem || ((key) => {
            const data = localStorage.getItem(key);
            if (!data) return null;
            try {
                const parsed = JSON.parse(data);
                return (parsed && parsed.expiry) ? parsed.value : parsed;
            } catch (e) { return null; }
        });

        const data = getCache('configureControlSettings');
        if (!data) return JSON.parse(JSON.stringify(DEFAULT_SETTINGS));
        
        const settings = JSON.parse(JSON.stringify(DEFAULT_SETTINGS));
        if (data.value) {
            settings.value = { ...settings.value, ...data.value };
        } else if (typeof data === 'object') {
            settings.value = { ...settings.value, ...data };
        }
        return settings;
    } catch (error) {
        return JSON.parse(JSON.stringify(DEFAULT_SETTINGS));
    }
}

function setConfigureControlSetting(key, value) {
    try {
        const settings = getConfigureControlSettings();
        settings.value[key] = value;
        
        if (window.setCacheItem && window.CACHE_EXPIRATION) {
            window.setCacheItem('configureControlSettings', settings, window.CACHE_EXPIRATION.ONE_YEAR);
        } else {
            localStorage.setItem('configureControlSettings', JSON.stringify(settings));
        }
        
        if (window.protectKey) window.protectKey('configureControlSettings');
        
    } catch (error) {
        console.error('Error saving configureControlSettings to localStorage:', error);
    }
}

function setupVariantButtons() {
    const variantContainers = document.querySelectorAll('#configure-pop-up .variants-container');
    const isMarketMapOverlayActive = () => document?.body?.classList?.contains('mmap-graph');
    const isMmap3D = () => {
        const el = document.getElementById('stock-3d-cube');
        const visualizer = el?.components?.['stock-cube-visualizer'];
        return isMarketMapOverlayActive() && (visualizer?.mmapViewMode === '3d' || visualizer?.data?.isMmap3D);
    };

    variantContainers.forEach(container => {
        const variants = container.querySelectorAll('.variant');
        const buttonCount = variants.length;

        container.style.setProperty('--button-count', buttonCount);

        const parentItem = container.closest('.item');
        const parentDataKey = parentItem ? parentItem.getAttribute('data-key') : null;

        variants.forEach((variant, index) => {
            variant.addEventListener('click', () => {
                if (parentItem && parentItem.classList.contains('disabled')) return;
                if (isMmap3D() && parentDataKey === 'animation') {
                    return;
                }
                if (isMarketMapOverlayActive() && parentDataKey !== 'animation') {
                    return;
                }
                variants.forEach(v => v.classList.remove('selected'));
                variant.classList.add('selected');

                container.style.setProperty('--selected-index', index);
            });
        });
    });
}

function initializeButtonPositions() {
    const ConfigureControlSettings = getConfigureControlSettings();
    const isMarketMapOverlayActive = () => document?.body?.classList?.contains('mmap-graph');
    const isMmap3D = () => {
        const el = document.getElementById('stock-3d-cube');
        const visualizer = el?.components?.['stock-cube-visualizer'];
        return isMarketMapOverlayActive() && (visualizer?.mmapViewMode === '3d' || visualizer?.data?.isMmap3D);
    };

    const fireworkContainer = document.querySelector('#firework-threshold');
    if (fireworkContainer) {
        const params = ["+3%", "+5%", "+10%", "+15%"];
        const num = params.indexOf(ConfigureControlSettings.value.fireworkThreshold);
        if (num !== -1) {
            fireworkContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            fireworkContainer.querySelectorAll('.variant')[num].classList.add('selected');
            fireworkContainer.style.setProperty('--selected-index', num);
        } else {
            fireworkContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            fireworkContainer.querySelectorAll('.variant')[0].classList.add('selected');
            fireworkContainer.style.setProperty('--selected-index', 0);
        }
    }

    const glowContainer = document.querySelector('#glow-threshold');
    if (glowContainer) {
        const glowParams = ["+25%", "+50%", "+100%", "+150%", "+200%"];
        const num = glowParams.indexOf(ConfigureControlSettings.value.glowThreshold);
        if (num !== -1) {
            glowContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            glowContainer.querySelectorAll('.variant')[num].classList.add('selected');
            glowContainer.style.setProperty('--selected-index', num);
        } else {
            glowContainer.querySelectorAll('.variant').forEach(v => v.classList.remove('selected'));
            glowContainer.querySelectorAll('.variant')[2].classList.add('selected');
            glowContainer.style.setProperty('--selected-index', 2);
        }
    }

    const mathFunctionContainer = document.querySelector('.item[data-key="math-function"] .variants-container');
    if (mathFunctionContainer) {
        const index = ConfigureControlSettings.value.chartMathFunction === 'Linear' ? 1 : 0;
        mathFunctionContainer.querySelectorAll('.variant')[index].classList.add('selected');
        mathFunctionContainer.style.setProperty('--selected-index', index);
    }

    const animationItem = document.querySelector('.item[data-key="animation"]');
    if (animationItem) {
        if (isMmap3D()) {
            animationItem.style.opacity = '0.65';
            animationItem.style.pointerEvents = 'none';
        } else {
            animationItem.style.opacity = '1';
            animationItem.style.pointerEvents = 'auto';
        }
    }

    updateFireworkAuth();
}

function updateFireworkAuth() {
    let isAuth = false;
    try {
        let session = window.currentSession;
        if (!session && typeof window.AuthAPI !== 'undefined' && typeof window.AuthAPI.getStoredSession === 'function') {
            session = window.AuthAPI.getStoredSession();
        }
        if (!session) {
            const sessionStr = localStorage.getItem('auth_session');
            if (sessionStr) {
                const sessionItem = JSON.parse(sessionStr);
                session = sessionItem.value || sessionItem;
                const expiry = sessionItem.expiry;
                if (expiry && Date.now() > expiry) {
                    session = null;
                }
            }
        }
        if (session && (!session.user || !session.user.is_anonymous)) {
            isAuth = true;
        }
    } catch (e) {
        let session = window.currentSession;
        if (session && (!session.user || !session.user.is_anonymous)) {
            isAuth = true;
        }
    }
    const fireworkItem = document.querySelector('.item[data-key="firework"]');
    const fireworkThresholdItem = document.querySelector('.item[data-key="fireworkThreshold"]');

    if (fireworkItem) {
        if (!isAuth) {
            fireworkItem.classList.add('disabled');
        } else {
            fireworkItem.classList.remove('disabled');
        }
    }
    if (fireworkThresholdItem) {
        if (!isAuth) {
            fireworkThresholdItem.classList.add('disabled');
        } else {
            fireworkThresholdItem.classList.remove('disabled');
        }
    }
}

document.addEventListener('auth:session-changed', updateFireworkAuth);


document.addEventListener("DOMContentLoaded", function () {
    const configureButton = document.querySelector('#main-block .open-pop-up-configure');
    const configurePopUp = document.querySelector('#configure-pop-up');
    const configureBg = document.querySelector('#configure-pop-up .bg');
    const closeButton = document.querySelector('#close-configure-popup');
    const configureElements = document.querySelectorAll('#configure-pop-up .content .item');

    setupVariantButtons();

    configureButton.addEventListener('click', () => {
        configurePopUp.classList.add('show');
        initializeButtonPositions();
        
        if (window.gtag) gtag('event', `Desktop_CenterPanel_ConfigureClick`);
    })
    configureBg.addEventListener('click', () => {
        configurePopUp.classList.remove('show');
    })

    if (closeButton) {
        closeButton.addEventListener('click', () => {
            configurePopUp.classList.remove('show');
        });
    }
    let ConfigureControlSettings = getConfigureControlSettings();
    const body = document.querySelector("body");
    const isMarketMapOverlayActive = () => document?.body?.classList?.contains('mmap-graph');
    const isMmap3D = () => {
        const el = document.getElementById('stock-3d-cube');
        const visualizer = el?.components?.['stock-cube-visualizer'];
        return isMarketMapOverlayActive() && (visualizer?.mmapViewMode === '3d' || visualizer?.data?.isMmap3D);
    };

    configureElements.forEach(element => {
        element.addEventListener('click', () => {
            if (element.classList.contains('disabled')) return;
            
            const dataKey = element.getAttribute('data-key');
            if (isMmap3D() && dataKey === 'animation') {
                return;
            }
            if (isMarketMapOverlayActive() && dataKey !== 'animation') {
                return;
            }

            const selectedValue = element.getAttribute('data-value');


            if (selectedValue === "math-function") {
                const container = element.querySelector('.variants-container');
                const index = container.style.getPropertyValue('--selected-index')

                const newValue = index === '1' ? "Linear" : "Log";
                setConfigureControlSetting("chartMathFunction", newValue);

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        rebuild: true,
                        settings: {
                            chartMathFunction: newValue
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_ChartFunction`, { value: newValue });
            }

            if (selectedValue === "firework") {
                ConfigureControlSettings = getConfigureControlSettings();
                const newFireworkState = !ConfigureControlSettings.value.isFireworkOn;
                
                if (window.Fireworks && typeof window.Fireworks.toggleFireworks === 'function') {
                    window.Fireworks.toggleFireworks(newFireworkState);
                }
                
                setConfigureControlSetting("isFireworkOn", newFireworkState);

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        settings: {
                            isFireworkOn: newFireworkState
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_Fireworks`, { value: newFireworkState ? 'On' : 'Off' });
            }

            if (selectedValue === "animation") {
                ConfigureControlSettings = getConfigureControlSettings();
                const newAnimationState = !ConfigureControlSettings.value.isAnimationOn;
                setConfigureControlSetting("isAnimationOn", newAnimationState);

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        settings: {
                            isAnimationOn: newAnimationState
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_Animation`, { value: newAnimationState ? 'On' : 'Off' });
            }

            if (selectedValue === "glow") {
                ConfigureControlSettings = getConfigureControlSettings();
                const newGlowState = !ConfigureControlSettings.value.isGlowOn;
                setConfigureControlSetting("isGlowOn", newGlowState);

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        settings: {
                            isGlowOn: newGlowState
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_Glow`, { value: newGlowState ? 'On' : 'Off' });

            }

            if (selectedValue === "fireworkThreshold") {
                ConfigureControlSettings = getConfigureControlSettings();
                let newThreshold = '+3%';
                const selectedVariant = element.querySelector('.variant.selected');
                if (selectedVariant) {
                    newThreshold = selectedVariant.innerHTML;
                    setConfigureControlSetting("fireworkThreshold", newThreshold);
                }

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        settings: {
                            fireworkThreshold: newThreshold
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_FireworksThreshold`, { value: newThreshold });
            }

            if (selectedValue === "glowThreshold") {
                ConfigureControlSettings = getConfigureControlSettings();
                let newThreshold = '+100%';
                const selectedVariant = element.querySelector('.variant.selected');
                if (selectedVariant) {
                    newThreshold = selectedVariant.innerHTML;
                    setConfigureControlSetting("glowThreshold", newThreshold);
                }

                const event = new CustomEvent('configure-changed', {
                    detail: {
                        settings: {
                            glowThreshold: newThreshold
                        }
                    }
                });
                document.dispatchEvent(event);

                if (window.gtag) gtag('event', `Desktop_CenterPanel_Configure_GlowThreshold`, { value: newThreshold });
            }

            if (element.classList.contains('toggle')) {
                element.classList.toggle('selected')
            }
        });
        if (element.getAttribute('data-key') === "firework") {
            ConfigureControlSettings.value.isFireworkOn ? element.classList.add("selected") : element.classList.remove("selected");
        }

        if (element.getAttribute('data-key') === "animation") {
            ConfigureControlSettings.value.isAnimationOn ? element.classList.add("selected") : element.classList.remove("selected");
        }

        if (element.getAttribute('data-key') === "glow") {
            ConfigureControlSettings.value.isGlowOn ? element.classList.add("selected") : element.classList.remove("selected");
        }

        if (element.getAttribute('data-key') === "fireworkThreshold") {
            ConfigureControlSettings.value.fireworkThreshold ? element.classList.add("selected") : element.classList.remove("selected");
        }
    })
})
